import React, { useCallback, useRef } from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import { Nav, REGIONS, THEMES } from "@bloomberg/media-ui-nav";
import {
    type BannerData,
    type MenuItems,
} from "@bloomberg/media-ui-nav/dist/types";
import { useNav } from "@foundation/nav";

import GoogleAnalyticsEventTracker from "~utils/GoogleAnalyticsEventTracker";

import { useScrolling } from "./useScrolling";
import styles from "./styles.module.css";

const tracker = new GoogleAnalyticsEventTracker({
    category: "nav",
});

const bannersTracker = new GoogleAnalyticsEventTracker({
    category: "banners",
});

interface NavContainerProps {
    breakingNews?: BannerData;
    menuItems: MenuItems;
    useGrid?: boolean;
    region?: REGIONS;
    countryCode?: string;
}

export default function NavContainer({
    breakingNews,
    menuItems,
    useGrid,
    region = REGIONS.US,
    countryCode,
}: NavContainerProps) {
    const trackingFunction = useCallback(
        (eventAction: string, eventLabel: string) => {
            tracker.trackEvent({
                event: "navClick",
                action: eventAction,
                label: eventLabel,
            });
        },
        []
    );

    const bannersTrackingFunction = useCallback(
        (eventAction: string, eventLabel: string) => {
            bannersTracker.trackEvent({
                event: "bannersEvent",
                action: eventAction,
                label: eventLabel,
            });
        },
        []
    );

    const navRef = useRef(null);
    useScrolling(styles.stickyNav, navRef);

    return (
        <div className={styles.nav} ref={navRef}>
            <Nav
                bannerData={breakingNews}
                menuItems={menuItems}
                theme={THEMES.DARK}
                user={useNav().user}
                searchClient={useNav().searchClient}
                initializeSignInWithRegUI={useNav().initializeSignInWithRegUI}
                onSignOut={useNav().onSignOut}
                desktopBreakpointClassName={createClasses([
                    {
                        [styles.navDesktop]: !useGrid,
                        [styles.gridNavDesktop]: useGrid,
                    },
                ])}
                subscriptionUrl={useNav().subscriptionUrl}
                upgradeUrl={useNav().upgradeUrl}
                trackingFunction={trackingFunction}
                bannersTrackingFunction={bannersTrackingFunction}
                region={region}
                countryCode={countryCode}
            />
        </div>
    );
}
